import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const PastCylesHeader = () => {
    return (
        <Box sx={{ backgroundColor: (t) => t.palette.secondary.light, paddingY: 2 }}>
            <Container maxWidth="xl">
                <Button
                    component={Link}
                    to="/invoicing-payroll"
                    variant="outlined"
                    sx={{ paddingY: 1, border: 1 }}>
                    <Stack direction={'row'} gap={1}>
                        <Typography
                            color={'primary'}
                            fontWeight={(t) => t.typography.button.fontWeight}>
                            &lt;
                        </Typography>
                        <Typography
                            color={'primary'}
                            fontWeight={(t) => t.typography.button.fontWeight}>
                            Current Cycle
                        </Typography>
                    </Stack>
                </Button>
                <Box></Box>
            </Container>
        </Box>
    );
};

export default PastCylesHeader;
